import { render } from "./VImageInput.vue?vue&type=template&id=2b64025a"
import script from "./VImageInput.vue?vue&type=script&lang=js"
export * from "./VImageInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__